import { Colors } from '@back-office/core';
import Avatar, { AvatarProps } from '@material-ui/core/Avatar';
import React from 'react';
import styled from 'styled-components';

export enum EnrollmentStatus {
  pending = 'pending',
  approved = 'approved',
  rejected = 'rejected',
  cancelled = 'cancelled',
  completed = 'completed',
}

interface GcpEnrollmentStatusProps extends AvatarProps {
  size?: number;
  status?: EnrollmentStatus;
}

function chooseStatusColor(status: EnrollmentStatus): keyof Colors {
  switch (status) {
    case EnrollmentStatus.pending:
      return 'silver';
    case EnrollmentStatus.approved:
      return 'eucalyptus';
    case EnrollmentStatus.rejected:
      return 'redOrange';
    case EnrollmentStatus.cancelled:
      return 'redOrange';
    case EnrollmentStatus.completed:
      return 'eucalyptus';
    default:
      return 'goldenrod';
  }
}

const getSize = (size: number): string => {
  if (size) {
    return `${size}px`;
  }
  return '1rem';
};

export const GcpEnrollmentStatus = styled(
  ({ size, status, ...rest }: GcpEnrollmentStatusProps) => (
    <Avatar {...rest}>&nbsp;</Avatar>
  )
)<GcpEnrollmentStatusProps>`
  ${(props): string =>
    props?.status &&
    `background-color: ${
      props.theme.palette?.common[chooseStatusColor(props.status)]
    }`};
  height: ${(props) => getSize(props.size)}};
  width: ${(props) => getSize(props.size)}};
`;

export default GcpEnrollmentStatus;
